module.exports = __webpack_public_path__ + "static/drive3-min-85d21e6c8b26f1bd3916f08f5be78266.png";